import { defineComponent } from 'vue';
import ImageGalleryDesktop from '@/components/Blue/ProductDetailPage/Modules/ImageGalleryDesktop.vue';
import InfoPills from '@/components/Blue/ProductDetailPage/Modules/InfoPills.vue';
import ProductHeadline from '@/components/Blue/ProductDetailPage/Modules/ProductHeadline.vue';
import ArtikelnummerTrustpilotStueckzahl from '@/components/Blue/ProductDetailPage/Modules/ArtikelnummerTrustpilotStueckzahl.vue';
import ImageGalleryMobile from '@/components/Blue/ProductDetailPage/Modules/ImageGalleryMobile.vue';
import PriceCtaAndInfos from '@/components/Blue/ProductDetailPage/Modules/PriceCtaAndInfos.vue';
import FilterBox from '@/components/Blue/ProductDetailPage/Modules/FilterBox.vue';
import BenefitsList from '@/components/Blue/ProductDetailPage/Modules/BenefitsList.vue';
import KontaktInfo from '@/components/Blue/ProductDetailPage/Modules/KontaktInfo.vue';
import GebrauchteGeraeteVerkaufen from '@/components/Blue/ProductDetailPage/Modules/GebrauchteGeraeteVerkaufen.vue';
import StickyCtaButton from '@/components/Blue/ProductDetailPage/Modules/StickyCtaButton.vue';
import { mapActions, mapGetters } from 'vuex';
import ProductDescription from '@/components/Blue/ProductDetailPage/Modules/ProductDescription.vue';
import EmarsysRecos from '@/components/Blue/ProductDetailPage/Modules/EmarsysRecos.vue';
import BreadcrumbNav from '@/components/Blue/ProductDetailPage/Modules/BreadcrumbNav.vue';
export default defineComponent({
    name: 'product-detail-page-content',
    components: {
        BreadcrumbNav,
        ArtikelnummerTrustpilotStueckzahl,
        ImageGalleryDesktop,
        InfoPills,
        ProductHeadline,
        ImageGalleryMobile,
        PriceCtaAndInfos,
        FilterBox,
        BenefitsList,
        KontaktInfo,
        GebrauchteGeraeteVerkaufen,
        ProductDescription,
        StickyCtaButton,
        EmarsysRecos,
    },
    props: {
        productId: {
            type: Number,
            required: true,
        },
        supportDelay: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    computed: Object.assign(Object.assign({}, mapGetters('blue', {
        currentProduct: 'currentProduct',
    })), mapGetters('global', {
        isMobile: 'isMobile',
    })),
    methods: Object.assign({}, mapActions('blue', {
        loadCurrentProduct: 'LOAD_CURRENT_PRODUCT',
    })),
    provide() {
        return {
            supportDelay: this.supportDelay,
        };
    },
    mounted() {
        this.loadCurrentProduct(this.productId);
    },
});
